<template>
  <section v-if='urls' class='guides'>
    <vue-horizontal>
      <a v-for='(guide, index) in getPagesFromPaths(urls)' :key='index' @click='$router.push({ name: "guide", params: { guide: guide.uid, savePosition: savePosition }})' >
        <header>
          <h5 v-html="guide.strings.subtitle" />
          <h4 v-html="guide.strings.title" />
        </header>
        <summary v-html='guide.strings.excerpt' />
        <button v-html='"Read More"' />
      </a>
    </vue-horizontal>
  </section>
</template>

<script>
import mixins from '.././mixins.js';
import VueHorizontal from "vue-horizontal";

export default {
  components: {VueHorizontal},
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['block'],
  data: function() {
    return {
      current: false
    }
  },
  computed: {
    urls: function(){
      return this.block.content.guides.length ? this.block.content.guides : '';
    },
    savePosition: function(){
      return window.top.scrollY;
    }
  }
}
</script>

<style scoped>

  section.guides {
    /* left: calc((100vw - var(--main-max-width)) / -2 - 2.5rem);*/
    width: 100%;
    position: relative;
    display: block;
  }

  header {
    margin-bottom: 3em;
  }

  a {
    width: 18rem;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    height: 25rem;
    background-color: var(--white);
    padding: 3rem 2rem 1.25rem;
    border-radius: 2.5rem;
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
  }

  a > summary {
    top: 8rem;
    left: 2em;
    right: 2em;
    position: absolute;
    white-space: normal;
    max-width: 20em;
  }

  h5 {
    font-size: 1.2em;
  }

  h4 {
    font-size: 1.2em;
  }


  summary {
    margin-bottom: 3em;
    flex-grow: 5;
    line-height: 1.4em;
    letter-spacing: 0.035em;
  }

  button {
    position: absolute;
    bottom: 2.5rem;
    left: 0;
    right: 0;
    width: 12em;
    margin: auto;
    padding: 1em 3em;
    border-radius: 2em;
    margin-bottom: 0;
  }

  svg {
    width: 3rem;
    height: 3rem;
    position: absolute;
    top: 2rem;
    right: 2rem;
  }

  ul.half {
    margin-top: 0;
    width: 50% !important;
  }
</style>
